import React from 'react'
import PropTypes from 'prop-types'

import Styled from '../../final-transshipment.styled'

const ReportTableSummary = ({
  totalGeared,
  totalGearless,
  totalRatuGiok,
  gearlessColumns,
  totalBLQuantity,
  gearlessSummaryMap,
}) => {
  return (
    <Styled.Thead>
      <Styled.SubTotalRow>
        <Styled.Td colSpan={4}>SUB TOTAL</Styled.Td>
        <Styled.Td>{totalGeared}</Styled.Td>
        <Styled.Td>{totalRatuGiok}</Styled.Td>
        {/* Gearless Columns */}
        {gearlessColumns.length > 0 ? gearlessColumns.map((col, i) => (
          <Styled.Td key={`subtotal-gearless-${i}`}>{gearlessSummaryMap[col] ?? '-'}</Styled.Td>
        )) : (
          <Styled.Td colSpan={gearlessColumns.length}>-</Styled.Td>
        )}
        <Styled.Td>{totalGearless}</Styled.Td>
        <Styled.Td>{totalBLQuantity}</Styled.Td>
        <Styled.Td>-</Styled.Td>
      </Styled.SubTotalRow>
    </Styled.Thead>
  )
}

ReportTableSummary.propTypes = {
  totalGeared: PropTypes.number.isRequired,
  totalGearless: PropTypes.number.isRequired,
  totalRatuGiok: PropTypes.number.isRequired,
  gearlessColumns: PropTypes.array.isRequired,
  totalBLQuantity: PropTypes.object.isRequired,
  gearlessSummaryMap: PropTypes.object.isRequired,
}

export default ReportTableSummary